import {isApolloError, ServerError,} from "@apollo/client";


export function isNetworkConnectionError(error: Error) {
    return error.message?.includes("Failed to fetch");
}


export function isServerError(error: Error) {
    return isApolloError(error) && error.networkError && "response" in error.networkError;
}


export function isForbiddenError(error: Error) {
    if (!isApolloError(error) || !error?.networkError) {
        return false;
    }
    return (error.networkError as (ServerError)).statusCode == 403;
}


export function isServiceUnavailableError(error: Error) {
    if (!isApolloError(error) || !error?.networkError) {
        return false;
    }
    const errorTexts = [
        "Начало сеанса с информационной базой запрещено",
        "Ошибка разделенного доступа",
    ]
    const result = (error.networkError as (ServerError))?.result;
    const content: string = typeof result == "string" ? result : JSON.stringify(result || "");

    for (const errorText of errorTexts) {
        if (content.startsWith(errorText)) {
            return true;
        }
    }

    return false;
}